import { connect } from "react-redux";
import { getAuth } from "./AuthHelpers";
import { getProfileData } from "app/reducers/profile/profileAction";
import { FC } from "react";


function hasTransactionAccess ()  {

    const auth = getAuth()
    if (auth) {
        if (auth.TransactionAccess) {
            return true;
        }
        else{
            return false;
        }
    }
    return false;
}
  
export default hasTransactionAccess;
